import { useDispatch, useSelector } from "react-redux";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import { useEffect, useState } from "react";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import { getInvestigationByVehicleReplacementId, saveInvestigation } from "../../actions/InvestigationActions";
import { useNavigate, useParams } from "react-router-dom";
import Toast from "../../components/Toast";
import { getVehicleModelByMakeId } from "../../actions/VehicleModelActions";
import { getAllProductCategory } from "../../actions/ProductCategoryActions";
import { getAllProduct, getProductByCategoryId } from "../../actions/ProductActions";
import moment from "moment/moment";
import Mobilemenu from "../../layouts/mobile-menu";

function AddInvestigation() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();

    const [currentStep, setCurrentStep] = useState(1);
    const [formData, setFormData] = useState({
        'vehcile_registration_expiry': moment().format('YYYY-MM-DD'),
        'vehcile_service_date': moment().format('YYYY-MM-DD'),
    });
    const [allItems, setAllItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [subTotal, setSubTotal] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [netTotal, setNetTotal] = useState(0);
    const [customerVehicles, setCustomerVehicles] = useState({});
    const [files, setFiles] = useState([]);

    useEffect(() => {
        if (params.id && Object.keys(params.id).length > 0) {
            dispatch(getInvestigationByVehicleReplacementId(params.id));
            setFormData({
                ...formData,
                replace_vehicle_id: params.id,
            })
        }
    }, []);

    useEffect(() => {
        dispatch(getAllProductCategory(null, 99999, ''));
        dispatch(getAllProduct(null, 99999, ''));
    }, []);

    const productCategories = useSelector(state => state?.productCategory?.productCategories?.data);
    const products = useSelector(state => state?.product?.products?.data);
    // products)
    const investigationByVehicleReplacement = useSelector(state => state?.investigation?.investigationByVehicleReplacement);
    // investigationByVehicleReplacement)
    const handleChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });
        
    };

    const handleChangeVehicleType = (name, e) => {
        setFormData({
            ...formData,
            vehicle_type_id: e.vehicle_type_id,
            vehicle_type_name: e.name
        });
    }

    const handleChangeVehicleMake = (name, e) => {
        setFormData({
            ...formData,
            vehicle_make_id: e.vehicle_make_id,
            vehicle_make_name: e.name
        });
        // dispatch(getVehicleModelByMakeId(e.vehicle_make_id));
    }
    const vehicleModelByMakeId = useSelector(state => state?.vehicleModel?.VehicleModelByMake)

    const handleChangeVehicleModel = (e) => {
        setFormData({
            ...formData,
            vehicle_model_id: e.vehicle_model_id,
            vehicle_model_name: e.name
        });
        // formData)
    }

    const handleChangeVehicleColor = (name, e) => {
        setFormData({
            ...formData,
            color_id: e.color_id,
            vehicle_color_name: e.name
        });
        
    }

    const handleChangeVehicleState = (name, e) => {
        
        setFormData({
            ...formData,
            state_id: e.state_id,
            vehicle_state_name: e.name
        });
    }
    const handleChangeVehicleCode = (name, e) => {
        
        setFormData({
            ...formData,
            code_id: e.vehicle_code_id,
            code_name: e.name
        });
    }
    const handleChangeAccidentSide = (name, e) => {
        
        setFormData({
            ...formData,
            accident_side_id: e.id,
            accident_side: e.name
        });
    }

    const handleChangeDropdown = (name, value) => {
        // 'value', value)
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const next = () => {
        if (currentStep == 1 && !formData.customer_mobile) {
            Toast.fire({
                icon: 'error',
                title: 'Mobile Number is Required!'
            })
        } else if (currentStep == 1 && !formData.customer_name) {
            Toast.fire({
                icon: 'error',
                title: 'Customer Name is Required!'
            })
        } else if (currentStep == 2 && !formData.vehicle_state_name) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle State is Required!'
            })
        } else if (currentStep == 2 && !formData.code_name) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Code is Required!'
            })
        } else if (currentStep == 2 && !formData.customer_name) {
            Toast.fire({
                icon: 'error',
                title: 'Customer Name is Required!'
            })
        } else if (currentStep == 2 && !formData.chasis_no) {
            Toast.fire({
                icon: 'error',
                title: 'Chasis # is Required!'
            })
        } else if (currentStep == 2 && !formData.plate_number) {
            Toast.fire({
                icon: 'error',
                title: 'Plate # is Required!'
            })
        } else if (currentStep == 2 && !formData.vehicle_type_name) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Type is Required!'
            })
        } else if (currentStep == 2 && !formData.vehicle_make_name) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Make is Required!'
            })
        } else if (currentStep == 2 && !formData.vehicle_model_name) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Model is Required!'
            })
        } else if (currentStep == 2 && !formData.vehicle_color_name) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Color is Required!'
            })
        } else if (currentStep == 2 && !formData.repair_time) {
            Toast.fire({
                icon: 'error',
                title: 'Repair Time is Required!'
            })
        } else if (currentStep == 2 && !formData.vehcile_registration_expiry) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Registration Expiry is Required!'
            })
        } else if (currentStep == 2 && !formData.vehcile_service_date) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Service Date is Required!'
            })
        } else if (currentStep == 2 && !formData.vehcile_service_mile) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Service Mile is Required!'
            })
        } else if (currentStep == 2 && !formData.accident_side) {
            Toast.fire({
                icon: 'error',
                title: 'Accident Side is Required!'
            })
        } else {
            setCurrentStep(currentStep + 1);
        }
    };
    const back = () => {
        setCurrentStep(currentStep - 1);
    };

    const onClickAdd = () => {
        setAllItems(allItems => [selectedItem, ...allItems]);
    }

    useEffect(() => {
        if (allItems.length > 0) {
            setFormData({
                ...formData,
                detail: allItems,
            });
        }
    }, [allItems])

    useEffect(() => {
        if (netTotal != 0) {
            setFormData({
                ...formData,
                master_total_amount: netTotal,
                master_sub_total: subTotal,
                master_discount_percentage: discount,
            });
        }
    }, [netTotal])

    const [activeDiv, setActiveDiv] = useState('1');
    const getProducts = (categoryId) => {
        dispatch(getProductByCategoryId(categoryId));
        setActiveDiv(categoryId);
        // 'activeDiv', activeDiv)

    }

    const saveButton = () => {
        if (allItems.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'No Items Added!'
            })
        } else {
            let formData1 = new FormData();
            formData1.append('data', JSON.stringify(formData));
            for (var key in files) {
                formData1.append('images[]', files[key])
            }
            // formData1.append('images', files);
            dispatch(saveInvestigation(formData1, navigate));
        }
    }

    switch (currentStep) {
        case 1:
            return (
                <span>
                    <Mobilemenu />
                    <div className="content-body d-flex">
                        <Webmenu />
                        <div className="content">
                            <Topbar />

                            <Step1
                                data={investigationByVehicleReplacement?.customer}
                                handleChange={handleChange}
                                next={next}
                                formData={formData}
                                setFormData={setFormData}
                                setCustomerVehicles={setCustomerVehicles}
                            />
                        </div>
                    </div>
                </span>

            );
        case 2:
            return (
                <span>
                    <Mobilemenu />
                    <div className="content-body d-flex">
                        <Webmenu />
                        <div className="content">
                            <Topbar />
                            <Step2
                                data={investigationByVehicleReplacement?.vehicle}
                                handleChange={handleChange}
                                next={next}
                                back={back}
                                formData={formData}
                                handleChangeDropdown={handleChangeDropdown}
                                setFormData={setFormData}
                                currentStep={currentStep}
                                customerVehicles={customerVehicles}
                                handleChangeVehicleType={handleChangeVehicleType}
                                handleChangeVehicleMake={handleChangeVehicleMake}
                                handleChangeVehicleModel={handleChangeVehicleModel}
                                handleChangeVehicleColor={handleChangeVehicleColor}
                                handleChangeVehicleState={handleChangeVehicleState}
                                handleChangeVehicleCode={handleChangeVehicleCode}
                                handleChangeAccidentSide={handleChangeAccidentSide}
                                vehicleModelByMakeId={vehicleModelByMakeId}
                                setFiles={setFiles}
                                files={files}
                            />
                        </div>
                    </div>
                </span>
            );
        case 3:
            return (
                <span>
                    <Mobilemenu />
                    <div className="content-body d-flex">
                        <Webmenu />
                        <div className="content">
                            <Topbar />

                            <Step3
                                data={formData}
                                handleChange={handleChange}
                                next={next}
                                back={back}
                                productCategories={productCategories}
                                products={products}
                                onClickAdd={onClickAdd}
                                allItems={allItems}
                                setAllItems={setAllItems}
                                selectedItem={selectedItem}
                                setSelectedItem={setSelectedItem}
                                subTotal={subTotal}
                                setSubTotal={setSubTotal}
                                discount={discount}
                                setDiscount={setDiscount}
                                activeDiv={activeDiv}
                                setActiveDiv={setActiveDiv}
                                netTotal={netTotal}
                                getProducts={getProducts}
                                setNetTotal={setNetTotal}
                                saveButton={saveButton}
                            />
                        </div>
                    </div>
                </span>

            );
        case 4:
            return (
                <div className="content-body d-flex">
                    <Webmenu />
                    <div className="content">
                        <Topbar />

                        <Step3
                            data={formData}
                            handleChange={handleChange}
                            next={next}
                            back={back}
                            productCategories={productCategories}
                            products={products}
                            onClickAdd={onClickAdd}
                            allItems={allItems}
                            setAllItems={setAllItems}
                            selectedItem={selectedItem}
                            setSelectedItem={setSelectedItem}
                            subTotal={subTotal}
                            setSubTotal={setSubTotal}
                            discount={discount}
                            setDiscount={setDiscount}
                            netTotal={netTotal}
                            setNetTotal={setNetTotal}
                            saveButton={saveButton}
                        />
                    </div>
                </div>

            );
        default:
        // return <Submit data={formData} back={back} />;
    }
};

export default AddInvestigation;